<template>
  <div class="time-select-layout">
    <div class="time-select">
      <input class="input-time"
        v-model="timeStartInput"
        @input="onInputTimeStart()"
        placeholder="Start time"
        @focusout="onFocusOutTimeStart()">
      <div class="hint-wrapper">
        <time-hint v-for="(time, index) in timeStartHints"
                   v-bind:key="index"
                   :value="time"
                   @timeSelected="onSelectTimeStart(time)">

        </time-hint>
      </div>
    </div>
    <div class="divider"> - </div>
    <div class="time-select">
      <input class="input-time"
             v-model="timeEndInput"
             @input="onInputTimeEnd()"
             placeholder="End time"
             @focusout="onFocusOutTimeEnd()">

      <div class="hint-wrapper">
        <time-hint v-for="(time, index) in timeEndHints"
                   v-bind:key="index"
                   :value="time"
                   @timeSelected="onSelectTimeEnd(time)">

        </time-hint>
      </div>
    </div>
  </div>
</template>

<script>
import TimeHint from './TimeHint.vue'

export default {
  props: ['selectedDate'],
  name: 'TimeSelectLayout',
  components: {TimeHint},
  data () {
    return {
      timeStartInput: '',
      timeEndInput: '',
      timeStartHints: [],
      timeEndHints: []
    }
  },
  computed: {
    getTimeListStart () {
      let timeList = []

      for (let i = 0; i < 22; i++) {
        timeList.push(i < 10 ? '0' + i + ':00' : i + ':00')
      }

      return timeList
    },
    getTimeListEnd () {
      let timeList = []

      for (let i = 2 + parseInt(this.timeStartInput.split(':')[0]); i < 24; i++) {
        timeList.push(i < 10 ? '0' + i + ':59' : i + ':59')
      }

      return timeList
    }
  },
  methods: {
    onInputTimeStart () {
      const allowedRegex = /^[0-9:]*$/
      if (allowedRegex.test(this.timeStartInput)) {
        this.timeStartHints = this.getTimeListStart.filter(
          (v) => v.includes(this.timeStartInput)
        )
      }

      if (this.timeStartInput === '') {
        this.timeStartHints = []
      }
    },
    onInputTimeEnd () {
      if (this.timeStartInput.length === 0) {
        this.timeEndInput = ''
      }

      const allowedRegex = /^[0-9:]*$/
      if (allowedRegex.test(this.timeEndInput)) {
        this.timeEndHints = this.getTimeListEnd.filter(
          (v) => v.includes(this.timeEndInput)
        )
      }

      if (this.timeEndInput === '') {
        this.timeEndHints = []
      }
    },
    onSelectTimeStart (selectedTime) {
      this.timeStartHints = []
      this.timeStartInput = selectedTime
    },
    onSelectTimeEnd (selectedTime) {
      this.timeEndHints = []
      this.timeEndInput = selectedTime
    },
    onFocusOutTimeStart () {
      if (this.getTimeListStart.indexOf(this.timeStartInput) >= 0) {
        if (this.timeEndInput.length > 0) {
          this.$store.dispatch('selectStartTime', this.timeStartInput)
        }
      } else {
        this.timeStartInput = ''
        this.timeEndInput = ''
        this.$store.dispatch('selectStartTime', '00:00')
        this.$store.dispatch('selectEndTime', '23:59')
      }
      this.timeStartHints = []
      this.$store.dispatch('fetchAvailablePlaces')
    },
    onFocusOutTimeEnd () {
      if (this.getTimeListEnd.indexOf(this.timeEndInput) >= 0) {
        this.$store.dispatch('selectStartTime', this.timeStartInput)
        this.$store.dispatch('selectEndTime', this.timeEndInput)
      } else {
        this.timeEndInput = ''
        this.$store.dispatch('selectStartTime', '00:00')
        this.$store.dispatch('selectEndTime', '23:59')
      }
      this.timeEndHints = []
      this.$store.dispatch('fetchAvailablePlaces')
    }
  }
}
</script>

<style>
.time-select-layout {
  display: flex;
  height: 40px;
  align-items: center;
  gap: 8px;
}

.input-time {
  display: flex;
  width: 100px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #D0D5DD;
  background: #FFF;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  color: #252525;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.input-time:focus-visible {
  outline: 1px solid #EAECF0;
}

.time-select {
  position: relative;
}

.hint-wrapper {
  display: flex;
  padding: 4px 0px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  position: absolute;
  top: 44px;
  left: 0;
  border-radius: 8px;
  border: 1px solid #F2F4F7;
  background: #FFF;
  box-shadow: 0 4px 6px -2px rgba(16, 24, 40, 0.03), 0 12px 16px -4px rgba(16, 24, 40, 0.08);
  max-height: 150px;
  overflow-y: auto;
}

.hint-wrapper::-webkit-scrollbar {
  width: 5px;
  background: #FFFFFF;
}

.hint-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #EAECF0;
}

@media (max-width: 1200px) {
  .input-time {
    padding: 6px 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/CalendarComponent/TimeSelectLayout.vue